import React, { Component } from 'react';
import { isValidPhoneNumber, isPossiblePhoneNumber, formatPhoneNumberIntl } from 'react-phone-number-input'
import MuiAlert from '@mui/material/Alert';
import Swal from 'sweetalert2'
import { da } from 'date-fns/locale';
import moment from 'moment';
import { ToWords } from 'to-words';
import ReactGA from 'react-ga';
import { maxDate } from 'Constants';

import commonMessages from 'Constants/messages'
import { FormattedMessage } from 'react-intl';

export const validatePhoneNumber = (phoneNumber) => {
    return isValidPhoneNumber(phoneNumber)
  }
  
  export const removeMobileExtension = (phoneNumber) => {
    var res = phoneNumber.replace(/^\S*/i, "");
    return res;
  }
  
  export const formatPhoneNumber = (phoneNumber) => {
    return formatPhoneNumberIntl(phoneNumber)
  }
  


export const validateMobileNumber = (field, value) => {
    let returnValue = { error: '', value: '', test: true }
    value = value ? value.includes("+") ? `${value}` : `+${value}` : ''
    let international = formatPhoneNumber(`${value}`)
    let RemovedValue = removeMobileExtension(international).replace(/\s/g, '').trim()
    if (RemovedValue === '' && field.required) {
      returnValue.error = <FormattedMessage {...commonMessages.fieldMandatoryError} />;
      returnValue.test = false
    }
    else if (!validatePhoneNumber(`${value}`) && RemovedValue !== '') {
      returnValue.error = <FormattedMessage {...commonMessages.invalidValue} />;
      returnValue.test = false
    }
    else if (!validatePhoneNumber(`${value}`) && RemovedValue === '') {
      value = ''
    }
    else {
      returnValue.value = value
    }
    return returnValue
  }
  
  export const dateFormat = (dateValue, format, oldFormat) => {
    if (oldFormat) {
      return (moment(moment(dateValue, oldFormat)).format(format))
    }
    else if (dateValue) {
      return moment(dateValue).format(format)
    }
    else {
      return true
    }
  }

  
  export const validateDate = (date, minDate, maxDateValue, validate_wise) => {
    let error = '';
    let dateValue = new Date(date);
    let first_date = moment(maxDateValue);
    let second_date = moment(minDate);
    if (first_date.diff(second_date, 'days') < 0) {
      maxDateValue = ''
    }
    if (validate_wise === 'time') {
      validate_wise = null
    }
    else {
      validate_wise = 'days'
    }
    if (dateFormat(dateValue, 'DD-MM-YYYY') === 'Invalid date') {
      error = 'Invalid Date'
    }
    else if (minDate && maxDateValue && !moment(dateValue).isBetween(minDate, maxDateValue, validate_wise, '[]')) {
      error = `Date Range ${dateFormat(minDate, 'DD-MM-YYYY')} TO ${dateFormat(maxDateValue, 'DD-MM-YYYY')}`;
    }
    else if (minDate && !maxDateValue && !moment(dateValue).isBetween(minDate, maxDate, validate_wise, '[]')) {
      error = `Minimum Date ${dateFormat(minDate, 'DD-MM-YYYY')}`;
    }
    return error
  }
  
  export const Alert = React.forwardRef((props, ref) => {
    return <MuiAlert elevation={6} variant="filled" ref={ref} {...props} />;
  });

export const isMobile = () => window.innerWidth < 980

export const logout = () => {
  localStorage.removeItem('user');
  localStorage.removeItem('permissions');
  localStorage.removeItem('menu');
  localStorage.removeItem('token');
  localStorage.removeItem('fcm_token');
  window.location = '/login';
}

export const getUrlParam = () => {
  let path = window.location.search;
  const urlParams = new URLSearchParams(path);
  let pathState = {};
  for (const entry of urlParams.entries()) {
    pathState[entry[0]] = entry[1];
  }
  return pathState;
}

export const getServerSideProps = (pagination) => {
  let paginationOptions = {};
  let paginationPropKeys = {
    rowsPerPage: 10,
    serverSide: true,
    sortOrder: {
      name: '',
      direction: 'asc'
    },
    searchText: '',
    count: 0,
  };
  for (let [key, value] of Object.entries(paginationPropKeys)) {
    paginationOptions[key] = value;
    if (pagination && pagination.hasOwnProperty(key)) {
      paginationOptions[key] = pagination[key];
    }
  }
  return paginationOptions;
}

export const getPaginationProps = (paginationProps, searchStringArray, compColumns, paginatedData) => {
  let pagination = {};
  if (paginationProps) {
    if (paginationProps.hasOwnProperty('rowsPerPage') && paginationProps['rowsPerPage']) {
      pagination['limit'] = paginationProps['rowsPerPage'];
    }
    if (paginationProps.hasOwnProperty('page')) {
      pagination['pageno'] = paginationProps['page'] + 1;
    }
    if (paginationProps.hasOwnProperty('sortOrder') && paginationProps['sortOrder']) {
      pagination['ordering'] = paginationProps.sortOrder['name'];
      if (paginationProps.sortOrder['direction'] === 'desc') {
        pagination['ordering'] = `-${pagination.ordering}`;
      }
    }
    if (paginationProps.hasOwnProperty('searchText') && paginationProps['searchText']) {
      pagination['search'] = paginationProps['searchText'];
    }
    if (
      paginationProps.hasOwnProperty("filterList") &&
      paginationProps["filterList"]
    ) {
      let filterData = {};
      const compColumnsMap = getDataBindedKeyValueMap(compColumns);
      paginationProps["filterList"].map((temp, index) => {
        const colName = paginationProps["columns"][index]["name"];
        if (temp.length > 0) {
          filterData[compColumnsMap[colName].name] = temp;
          if (colName != compColumnsMap[colName].name) {
            filterData[compColumnsMap[colName].name] = getPaginatedDataBindedColumnArray(
              paginatedData,
              temp,
              compColumnsMap,
              colName,
              index
            ).toString();
          }
        }
      });
      pagination = { ...pagination, ...filterData };
    }
    if (searchStringArray && Array.isArray(searchStringArray) && searchStringArray.length > 0) {
      pagination['search'] = searchStringArray[searchStringArray.length - 1];
    }
    if (paginationProps.hasOwnProperty('custom') && typeof paginationProps['custom'] === 'object') {
      pagination = { ...pagination, ...paginationProps['custom'] };
    }
  }
  return pagination;
}

export function getFullName(firstName, middleName, lastName) {
  let name = firstName;
  if (middleName) {
    name += ' ' + middleName
  }
  name += ' ' + lastName
  return name;
}

const getDataBindedKeyValueMap = (array) => {
  const colNameMap = {};
  for (const index in array) {
    const element = array[index];
    colNameMap[element.name] = { name: element.name, index: parseInt(index) };
    if (element.column_data_bind) {
      colNameMap[element.name] = {
        name: array[element.column_data_bind].name,
        index: element.column_data_bind,
      };
    }
  }
  return colNameMap;
};

const getPaginatedDataBindedColumnArray = (
  array,
  filteredList,
  colBindMap,
  columnKey,
  index
) => {
  let dataList = [];
  let bindIndex = colBindMap[columnKey].index;
  for (let element of array) {
    if (filteredList.includes(element.data[index])) {
      let temp = element.data[bindIndex];
      dataList.push(temp);
    }
  }
  dataList = Array.from(new Set(dataList));
  return dataList;
};

export function getPathName(payload){
  let returnValue=''
  if(payload.screen==="helpcenter_ticket"){
    returnValue=`ticket/detail/?ticket_id=${payload.ticket_id}`
  }
  return returnValue
}

/**
 * Validate mobile number format (matches backend validate_mobile_number function).
 * 
 * Rules:
 * - Should contain only numbers or + symbol at the beginning
 * - Max 13 characters, min 10 characters
 * - If starts with +: 10-12 digits after + (total length 11-13)
 * - If no +: 10-13 digits
 * 
 * @param {string} mobileNum - The mobile number string to validate
 * @param {boolean} required - Whether the mobile number is required (default: true)
 * @returns {object} - { isValid: boolean, error: string | null }
 */
export const validateMobileNumberFormat = (mobileNum, required = true) => {
  if (!mobileNum) {
    mobileNum = '';
  } else {
    mobileNum = String(mobileNum).trim();
  }

  // Check if required
  if (required && !mobileNum) {
    return { isValid: false, error: 'Mobile number is required' };
  }

  // If not required and empty, it's valid
  if (!required && !mobileNum) {
    return { isValid: true, error: null };
  }

  // Check length (min 10, max 13)
  if (mobileNum.length < 10) {
    return { isValid: false, error: 'Mobile number must be at least 10 characters' };
  }

  if (mobileNum.length > 13) {
    return { isValid: false, error: 'Mobile number must not exceed 13 characters' };
  }

  // Check format: should start with + (optional) and rest should be digits only
  const pattern = /^\+?\d+$/;
  if (!pattern.test(mobileNum)) {
    return { isValid: false, error: 'Mobile number should contain only numbers or + symbol at the beginning' };
  }

  // Additional validation based on format
  if (mobileNum.startsWith('+')) {
    // After +, should have 10-12 digits (total length 11-13)
    const digitsAfterPlus = mobileNum.substring(1);
    if (digitsAfterPlus.length < 10 || digitsAfterPlus.length > 12) {
      return { isValid: false, error: 'Mobile number with + should have 10-12 digits after the + symbol' };
    }
  }

  return { isValid: true, error: null };
};

/**
 * 10-digit mobile: digits only (no spaces or +). Typical Indian numbering (starts 6–9).
 * @param {string} mobileNum
 * @param {boolean} required
 * @returns {{ isValid: boolean, error: string | null }}
 */
export const validateIndianMobileDigits10 = (mobileNum, required = true) => {
  const raw = mobileNum != null ? String(mobileNum).trim() : "";
  if (!raw) {
    return required
      ? { isValid: false, error: "Mobile number is required" }
      : { isValid: true, error: null };
  }
  const digits = raw.replace(/\D/g, "");
  if (digits.length !== 10) {
    return { isValid: false, error: "Enter exactly 10 digits" };
  }
  if (!/^[6-9]\d{9}$/.test(digits)) {
    return { isValid: false, error: "Enter a valid 10-digit mobile number" };
  }
  return { isValid: true, error: null };
};